import axios from "axios"
import { API_URL, getHeader } from "../config"

export const getHighlight = async() => {
    const { data } = await axios.get(API_URL + `/api/highlight/SHCSKWB`);
    
    return data;
} 
 
export const getNews = async() => {
   
    const { data } = await axios.get(API_URL + `/api/news/SHCSKWB`);
   
    return data;
} 
export const getNewsInner = async() => {
   
    const { data } = await axios.get(API_URL + `/api/news/all/SHCSKWB`);
    
    return data;
} 

export const getEvents = async() => {
    const { data } = await axios.get(API_URL + `/api/events/SHCSKWB`);
   
    return data;
} 

export const getEventsinner = async() => {
    const { data } = await axios.get(API_URL + `/api/events/All/SHCSKWB`);
   
    return data;
} 

export const getGallery = async() => {
    const { data } = await axios.get(API_URL + `/api/gallery/SHCSKWB`);
    return data;
} 

export const getGalleryInner = async() => {
    const { data } = await axios.get(API_URL + `/api/gallery/All/SHCSKWB`);
    return data;
} 

export const getSubGallery = async(id) => {
   
    const { data } = await axios.get(API_URL + `/api/subGallery?id=${id}`);
    
    return data;
} 

export const getNotification = async() => {
    const { data } = await axios.get(API_URL + `/api/notification/SHCSKWB`,getHeader());
     
    return data;
} 

export const getTopper = async() => {
    const { data } = await axios.get(API_URL + `/api/topper/SHCSKWB`,getHeader());
    return data;
} 

export const getOnlineRegistration = async() => {
    const { data } = await axios.get(API_URL + `/api/onlineRegistration/SHCSKWB`,getHeader());
     
    return data;
} 


export const getPrincipalMessage = async() => {
    const { data } = await axios.get(API_URL + `/api/principalMessage/SHCSKWB`, getHeader());
    return data;
} 
 
export const getVideo = async() => {
    const { data } = await axios.get(API_URL + `/api/video/All/SHCSKWB`);
    return data;
} 
export const postTransferCertificate = async(name,admission) => { 

    const { data } = await axios.post(API_URL + `/api/tc/SHCSKWB`,{name,admission},getHeader());
    return data;
}
  
export const form1 = async (formData, header, type) => {
    try {
        const { data } = await axios.post(`${API_URL}/api/form/SHCSKWB/${type}`, formData, header);
        console.log(data)
        return data;
    } catch (error) {
        console.error('Error in form submission:', error);
        if (error.response) {
            console.error('Error response data:', error.response.data); 
        }
        throw error;
    }
  };
  export const academicCalender = async() => {
    const { data } = await axios.get(API_URL + `/api/academicCalender/all/SHCSKWB`, getHeader());
    console.log("academic calender", data)
    return data;
}
export const getBirthdays = async() => {
    const { data } = await axios.get(API_URL + `/api/birthdays/SHCSKWB`);
    console.log(data)
    return data;
}